<page-load-header *ngIf="!initialized"></page-load-header>


<div *ngIf="initialized" class="container-fluid mt-3">
  <!-- <div class="text-center"><img class="img img-fluid" src="/fetchimage?filename={{page.sponsorshipLogo}}&width=320"></div> -->
  <a  [routerLink]="['../../../', homeRoute]">< Back To Sponsors </a>
  <h3>{{page.title}}</h3>
  <div><a target="_blank" href="https://{{page.website}}">https://{{page.website}}</a></div>
  <div [editorHTML]="page.body"></div>
</div>
